// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaFile, FaLaptop } from "react-icons/fa";
// import { LiaStarSolid } from "react-icons/lia";
// import { BiArrowBack } from "react-icons/bi";
// import { FaRegTrashAlt } from "react-icons/fa";
// import { TbBallpen } from "react-icons/tb";
// import Background from "../../../assets/background.png";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";
// import { getHitID } from "../../../config/HitIDStorage";
// import { toast } from "react-toastify";
// import { IoChevronDownOutline, IoChevronUp } from "react-icons/io5";
// import { ImUpload } from "react-icons/im";
// function TeacherMessage() {
//   const ID = getHitID();

//   const [errors, setErrors] = useState({});
//   const admin = JSON.parse(localStorage.getItem("edo-admin"));
//   const [teacherDetails, setTeacherDetails] = useState(null);
//   const [bySubjectsData, setBySubjectsData] = useState({});
//   const [bySkillData, setBySkillData] = useState([]);
//   const [byTimeSlotData, setByTimeSlotData] = useState([]);
//   const [loading, setLoading] = useState(true); // Add loading state
//   const [profileImage, setProfileImage] = useState(null);
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [editing, setEditing] = useState({
//     about: false,
//     education: false,
//     job: false,
//   });

//   const [formData, setFormData] = useState({
//     bio: "",
//     degree: "",
//     school: "",
//     graduation_year: "",
//     title: "",
//     company: "",
//     start_month: "",
//     start_year: "",
//     end_month: "",
//     end_year: "",
//     description: "",
//   });

//   useEffect(() => {
//     setLoading(true); // Start loading before data fetch

//     axios
//       .get(`${apiKey}/api/edolutions/admin/teacherdetails/${ID}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((response) => {
//         // Add this line to check the data structure

//         setTeacherDetails(response.data.teacherDetails);
//         setBySubjectsData(response.data.bySubjectsData);

//         setBySkillData(response.data.skillsData);
//         setByTimeSlotData(response.data.timeSlotData);
        
//         setProfileImage(teacherDetails.photo);

//         setFormData({
//           bio: response.data.teacherDetails.bio,
//           degree: response.data.teacherDetails.degree,
//           school: response.data.teacherDetails.school,
//           graduation_year: response.data.teacherDetails.graduation_year,
//           title: response.data.teacherDetails.title,
//           company: response.data.teacherDetails.company,
//           start_month: response.data.teacherDetails.start_month,
//           start_year: response.data.teacherDetails.start_year,
//           end_month: response.data.teacherDetails.end_month,
//           end_year: response.data.teacherDetails.end_year,
//           description: response.data.teacherDetails.description,
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       })
//       .finally(() => {
//         setLoading(false); // Stop loading after data fetch
//       });
//   }, [ID, admin?.token]);


//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     const ID = getHitID(); // Get the ID dynamically

//     // Validation: Check if file exists
//     if (!file) {
//       toast.error("No file selected!", {
//         position: "bottom-right",
//         autoClose: 5000,
//         theme: "colored",
//       });
//       return;
//     }

//     // Validation: Allowed file types
//     const validExtensions = ["image/png", "image/jpeg"];
//     if (!validExtensions.includes(file.type)) {
//       toast.error("Only PNG or JPG files are allowed.", {
//         position: "bottom-right",
//         autoClose: 5000,
//         theme: "colored",
//       });
//       e.target.value = ""; // Reset the file input
//       return;
//     }

//     // Validation: File size (1MB = 1 * 1024 * 1024 bytes)
//     const maxSize = 1 * 1024 * 1024;
//     if (file.size > maxSize) {
//       toast.error("File size must be less than 1MB.", {
//         position: "bottom-right",
//         autoClose: 5000,
//         theme: "colored",
//       });
//       e.target.value = ""; // Reset the file input
//       return;
//     }

//     // Prepare the file for upload
//     const formData = new FormData();
//     formData.append("photo", file);
//     formData.append("user_id", ID); // Add the user ID to the request

//     // Upload the image
//     axios
//       .post(`${apiKey}/api/edolutions/teacher-image-upload`, formData, {

//       })
//       .then((res) => {
//         toast.success(res.data.message, {
//           position: "bottom-right",
//           autoClose: 5000,
//           theme: "colored",
//           style: {
//             backgroundColor: "#4FD1C5", // Customize background color
//             color: "#fff", // Customize text color
//           },
//         });

//         // Fetch the updated profile image
//         const formData1 = new FormData();
//         formData1.append("user_id", ID);

//         axios
//         .post(`${apiKey}/api/edolutions/get-image`, formData1) // Change from GET to POST
//         .then((res) => {
//           if (res.data[0]) {
//             setProfileImage(res.data[0].photo_url);
//           }
//         })
//         .catch((err) => {
//           console.error("Error fetching profile image:", err);
//           toast.error("Failed to fetch updated profile image.", {
//             position: "bottom-right",
//             autoClose: 5000,
//             theme: "colored",
//           });
//         });
//       })
//       .catch((err) => {
//         console.error("Error uploading image:", err);
//         toast.error(err.response?.data?.message || "Image upload failed.", {
//           position: "bottom-right",
//           autoClose: 5000,
//           theme: "colored",
//         });
//       });
//   };

//   const handleEditClick = (section) => {
//     setEditing({ ...editing, [section]: !editing[section] });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSave = () => {
//     axios
//       .post(
//         `${apiKey}/api/edolutions/admin/updateTeacherDetails/${ID}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${admin?.token}`,
//           },
//         }
//       )
//       .then((response) => {
//         setTeacherDetails(response.data.teacherDetails);
//         setEditing({
//           about: false,
//           education: false,
//           job: false,
//         });
//         setErrors({});
//         toast.success("Profile Details Update  Successfully", {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//           style: {
//             backgroundColor: "#4FD1C5", // Customize background color
//             color: "#fff", // Customize text color
//           },
//         });
//       })
//       .catch((error) => {
//         console.error("Error updating data:", error);
//         if (
//           error.response &&
//           error.response.data &&
//           error.response.data.errors
//         ) {
//           setEditing({
//             about: true,
//             education: true,
//             job: true,
//           });
//           setErrors(error.response.data.errors);
//           toast.error("Error updating profile. Please check the fields.", {
//             position: "bottom-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             theme: "colored",
//           });
//         } else {
//           toast.error("An unexpected error occurred. Please try again later.", {
//             position: "bottom-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             theme: "colored",
//           });
//         }
//       });
//   };

//   const formatTime = (time) => {
//     const [hour, minute] = time.split(":");
//     const suffix = hour >= 12 ? "PM" : "AM";
//     const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
//     return `${formattedHour}:${minute} ${suffix}`;
//   };

//   const navigate = useNavigate();
//   const [expandedClasses, setExpandedClasses] = useState({});

//   const toggleClass = (className) => {
//     setExpandedClasses((prev) => ({
//       ...prev,
//       [className]: !prev[className],
//     }));
//   };

//   // time slot work
//   const [visibleCount, setVisibleCount] = useState(4);
//   const [showAll, setShowAll] = useState(false);

//   // Function to toggle showing more or less time slots
//   const handleToggleView = () => {
//     if (showAll) {
//       setVisibleCount(4); // Reset to initial visible count
//     } else {
//       setVisibleCount(byTimeSlotData.length); // Show all time slots
//     }
//     setShowAll((prevState) => !prevState); // Toggle between showing more and less
//   };

//   return (
//     <div className="m-3 flex flex-col break-words max-sm:w-[95%] max-sm:mx-auto w-full mb-4 shadow-lg bg-white rounded-lg border-0">
//       <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//         {loading ? (
//           <div>
//             <div colSpan="9" className="py-5 px-1 text-center">
//               <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                 <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                 <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                   Cabil...
//                 </p>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="w-full xl:p-5 sm:p-0">
//             <div className="p-3">
//               <div
//                 className="flex gap-2 items-center cursor-pointer"
//                 onClick={() => navigate(-1)}
//               >
//                 <BiArrowBack className="h-5 w-5" />
//                 <p className="text-[14px]">Back</p>
//               </div>
//               <div className="xl:mx-10 mx-0">
//                 <div
//                   className="bg-cover p-4"
//                   style={{ backgroundImage: `url(${Background})` }}
//                 >
//                   <div className="flex flex-wrap items-center justify-between gap-7 my-7">
//                     <div className="flex flex-col items-center justify-center text-center">
//                       <div>
//                         {teacherDetails && (
//                           <div className="flex flex-col  items-center justify-center">
//                             <div className="">
//                               <img
//                                 className="rounded-full border w-40 h-40"
//                                 src={
//                                   profileImage
//                                     ? profileImage
//                                     : teacherDetails.photo
//                                       ? `${apiKey}/userProfile/${teacherDetails.photo}`
//                                       : `${apiKey}/userProfile/87654321.png`
//                                 }
//                                 alt="Profile"
//                               />
//                             </div>
//                             <div className="relative inline-block">
//                               <input
//                                 onChange={handleImageUpload}
//                                 type="file"
//                                 id="uploadBtn"
//                                 className=""
//                                 accept="image/png, image/jpeg" // Restricts file types in the file picker
//                               />
//                               <label
//                                 htmlFor="uploadBtn"
//                                 className="flex items-center cursor-pointer"
//                                 onMouseEnter={() => setShowTooltip(true)}
//                                 onMouseLeave={() => setShowTooltip(false)}
//                               >
//                                 <ImUpload className="w-6 h-6 ml-32 -mt-6" />
//                               </label>
//                               {showTooltip && (
//                                 <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 p-2 w-48 font-medium text-black bg-white text-sm rounded shadow-lg z-10">
//                                   Only PNG or JPEG Image under 1MB is allowed.
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                       <div>
//                         {teacherDetails && (
//                           <p className="font-semibold capitalize text-xl">
//                             {teacherDetails.user_name}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-3">
//               <div className="md:px-4 md:py-4 col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 space-y-5">
//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-3">About</p>
//                   {editing.about ? (
//                     <textarea
//                       name="bio"
//                       value={formData.bio}
//                       onChange={handleChange}
//                       className="w-full border p-2 rounded"
//                       placeholder="Bio"
//                     />
//                   ) : (
//                     <p className="text-sm font-light">{teacherDetails?.bio}</p>
//                   )}
//                   {errors.bio && <p className="text-red-500">{errors.bio}</p>}
//                   <button
//                     onClick={() => handleEditClick("about")}
//                     className="text-blue-500 mt-5"
//                   >
//                     {editing.about ? <FaRegTrashAlt /> : <TbBallpen />}
//                   </button>
//                 </div>

//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-3">Education</p>
//                   {editing.education ? (
//                     <div>
//                       <input
//                         name="degree"
//                         value={formData.degree}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Degree"
//                       />
//                       {errors.degree && (
//                         <p className="text-red-500">{errors.degree}</p>
//                       )}
//                       <input
//                         name="school"
//                         value={formData.school}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="School"
//                       />
//                       {errors.school && (
//                         <p className="text-red-500">{errors.school}</p>
//                       )}
//                       <input
//                         name="graduation_year"
//                         value={formData.graduation_year}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Graduation Year"
//                       />
//                       {errors.graduation_year && (
//                         <p className="text-red-500">{errors.graduation_year}</p>
//                       )}
//                     </div>
//                   ) : (
//                     <div>
//                       <p className="text-sm font-semibold">
//                         {teacherDetails?.degree}
//                       </p>
//                       <p className="text-sm font-light">
//                         {teacherDetails?.school}
//                       </p>
//                       <p className="text-sm font-light mb-3">
//                         Graduation Year: {teacherDetails?.graduation_year}
//                       </p>
//                     </div>
//                   )}
//                   <button
//                     onClick={() => handleEditClick("education")}
//                     className="text-blue-500 mt-5"
//                   >
//                     {editing.education ? <FaRegTrashAlt /> : <TbBallpen />}
//                   </button>
//                 </div>

//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-3">Job</p>
//                   {editing.job ? (
//                     <div>
//                       <input
//                         name="title"
//                         value={formData.title}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Job Title"
//                       />
//                       {errors.title && (
//                         <p className="text-red-500">{errors.title}</p>
//                       )}
//                       <input
//                         name="company"
//                         value={formData.company}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Company"
//                       />
//                       {errors.company && (
//                         <p className="text-red-500">{errors.company}</p>
//                       )}
//                       <input
//                         name="start_month"
//                         value={formData.start_month}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Start Month"
//                       />
//                       {errors.start_month && (
//                         <p className="text-red-500">{errors.start_month}</p>
//                       )}
//                       <input
//                         name="start_year"
//                         value={formData.start_year}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Start Year"
//                       />
//                       {errors.start_year && (
//                         <p className="text-red-500">{errors.start_year}</p>
//                       )}
//                       <input
//                         name="end_month"
//                         value={formData.end_month}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="End Month"
//                       />
//                       {errors.end_month && (
//                         <p className="text-red-500">{errors.end_month}</p>
//                       )}
//                       <input
//                         name="end_year"
//                         value={formData.end_year}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="End Year"
//                       />
//                       {errors.end_year && (
//                         <p className="text-red-500">{errors.end_year}</p>
//                       )}
//                       <textarea
//                         name="description"
//                         value={formData.description}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         placeholder="Job Description"
//                       />
//                       {errors.description && (
//                         <p className="text-red-500">{errors.description}</p>
//                       )}
//                     </div>
//                   ) : (
//                     <div>
//                       <p className="text-sm font-semibold">
//                         {teacherDetails?.title}
//                       </p>
//                       <p className="text-sm font-light">
//                         {teacherDetails?.company}
//                       </p>
//                       <p className="text-sm font-light">
//                         Start Date: {teacherDetails?.start_month},{" "}
//                         {teacherDetails?.start_year}
//                       </p>
//                       <p className="text-sm font-light mb-3">
//                         End Date: {teacherDetails?.end_month},{" "}
//                         {teacherDetails?.end_year}
//                       </p>
//                       <p className="text-sm font-light mb-3">
//                         Job Description: {teacherDetails?.description}
//                       </p>
//                     </div>
//                   )}
//                   <button
//                     onClick={() => handleEditClick("job")}
//                     className="text-blue-500 mt-5"
//                   >
//                     {editing.job ? <FaRegTrashAlt /> : <TbBallpen />}
//                   </button>
//                 </div>
//               </div>
//               <div className="col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 md:px-4 md:py-4 overflow-x-auto space-y-5 mt-5 md:mt-0">
//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-2">Time</p>
//                   {byTimeSlotData && byTimeSlotData.length > 0 ? (
//                     <div>
//                       {byTimeSlotData.slice(0, visibleCount).map((timeSlot) => (
//                         <div key={timeSlot.id}>
//                           <p className="text-sm font-semibold capitalize">
//                             {timeSlot.day_name}:
//                           </p>
//                           <p className="text-sm font-normal">
//                             Start Time: {formatTime(timeSlot.start_time)} End
//                             Time: {formatTime(timeSlot.end_time)}
//                           </p>
//                         </div>
//                       ))}
//                       {byTimeSlotData.length > 4 && (
//                         <button
//                           className="mt-3 text-blue-500 font-semibold"
//                           onClick={handleToggleView}
//                         >
//                           {showAll ? "Show Less" : "View More"}
//                         </button>
//                       )}
//                     </div>
//                   ) : (
//                     <p>No time slots available</p>
//                   )}
//                 </div>

//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-2">Skills</p>
//                   {bySkillData && bySkillData.length > 0 ? (
//                     bySkillData.map((skill) => (
//                       <p className="text-sm font-semibold" key={skill.id}>
//                         {skill.skill_name}
//                       </p>
//                     ))
//                   ) : (
//                     <p>No skills available</p>
//                   )}
//                 </div>

//                 <div className="border rounded-3xl shadow-xl p-5">
//                   <p className="text-2xl font-semibold mb-3">
//                     Profile Overview
//                   </p>

//                   <p className="flex text-yellow-400 items-center">
//                     <LiaStarSolid />
//                     <LiaStarSolid />
//                     <LiaStarSolid />
//                     <span className="text-black">5.0</span>
//                   </p>
//                   <div>
//                     <div className="flex items-center text-base font-semibold space-x-1 mb-2">
//                       <p className="text-lg">
//                         <FaLaptop />
//                       </p>
//                       <p>Home Tuition Location</p>
//                     </div>
//                     <div>
//                       {teacherDetails &&
//                         teacherDetails.location ? (
//                         <p className="text-sm font-semibold">
//                           {teacherDetails.location}
//                         </p>
//                       ) : (
//                         <p>No location available</p>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="border rounded-3xl shadow-xl p-5 bg-white">
//                   <p className="text-2xl font-semibold mb-5 text-gray-800 flex items-start justify-between">Subjects <Link to={'/admins/editsubject'} className="text-blue-400"><TbBallpen /></Link > </p>

//                   <div className="flex items-center text-lg font-semibold mb-4 text-black">
//                     <p className="mr-2">
//                       <FaFile />
//                     </p>
//                     <p>Main Classes & Subjects</p>
//                   </div>
//                    {console.log(bySubjectsData)}   
//                   {bySubjectsData && Object.keys(bySubjectsData).length > 0 ? (
//                     Object.keys(bySubjectsData).map((className) => (
//                       <div key={className} className="mb-4 border-b pb-2">
//                         <div
//                           className="cursor-pointer flex items-center justify-between text-md font-medium text-gray-600 hover:text-blue-700"
//                           onClick={() => toggleClass(className)}
//                         >
//                           <p>{className || "General"}</p>
//                           <span>
//                             {expandedClasses[className] ? <IoChevronUp /> : <IoChevronDownOutline />}
//                           </span>
//                         </div>

//                         {expandedClasses[className] && (
//                           <ul className="pl-5 mt-2 space-y-2">
//                             {bySubjectsData[className] &&
//                               bySubjectsData[className].map((subject, index) => (
//                                 <li key={index} className="text-sm text-gray-700">
//                                   <p className="font-semibold text-gray-800">{subject.subject}</p>
//                                   <div className="flex items-center space-x-4 text-xs text-gray-600">
//                                     <span>Home Charges: {subject.home_charges ? `Rs${subject.home_charges}` : "N/A"}</span>
//                                     <span>Online Charges: {subject.online_charges ? `Rs${subject.online_charges}` : "N/A"}</span>
//                                   </div>
//                                 </li>
//                               ))}
//                           </ul>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <p className="text-gray-500">No subjects available</p>
//                   )}
//                 </div>

//               </div>
//             </div>
//             {editing.about || editing.education || editing.job ? (
//               <button
//                 onClick={handleSave}
//                 className="bg-blue-500 text-white p-2 rounded mt-4"
//               >
//                 Save Changes
//               </button>
//             ) : null}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default TeacherMessage;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFile, FaLaptop } from "react-icons/fa";
import { LiaStarSolid } from "react-icons/lia";
import { BiArrowBack } from "react-icons/bi";
import { FaRegTrashAlt } from "react-icons/fa";
import { TbBallpen } from "react-icons/tb";
import Background from "../../../assets/background.png";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { getHitID } from "../../../config/HitIDStorage";
import { toast } from "react-toastify";
import { IoChevronDownOutline, IoChevronUp } from "react-icons/io5";
import { ImUpload } from "react-icons/im";
import { useTranslation } from "react-i18next";

function TeacherMessage() {
  const { t } = useTranslation();
  const ID = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [teacherDetails, setTeacherDetails] = useState(null);
  const [bySubjectsData, setBySubjectsData] = useState({});
  const [bySkillData, setBySkillData] = useState([]);
  const [byTimeSlotData, setByTimeSlotData] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const [editing, setEditing] = useState({
    about: false,
    education: false,
    job: false,
  });

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    bio: "",
    degree: "",
    school: "",
    graduation_year: "",
    title: "",
    company: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    description: "",
  });

  const [expandedClasses, setExpandedClasses] = useState({});
  const [visibleCount, setVisibleCount] = useState(4);
  const [showAll, setShowAll] = useState(false);

  // ---------- utils ----------
  const Skeleton = ({ className = "" }) => (
    <div className={`animate-pulse bg-gray-200/60 rounded-2xl ${className}`} />
  );

  const formatTime = (time) => {
    if (!time) return "N/A";
    const [h, m] = time.split(":");
    const hour = parseInt(h || "0", 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const formattedHour = (hour % 12) || 12;
    return `${formattedHour}:${m ?? "00"} ${suffix}`;
  };

  const toggleClass = (className) => {
    setExpandedClasses((prev) => ({ ...prev, [className]: !prev[className] }));
  };

  const handleToggleView = () => {
    if (showAll) setVisibleCount(4);
    else setVisibleCount(byTimeSlotData.length);
    setShowAll((p) => !p);
  };

  // ---------- data fetch ----------
  useEffect(() => {
    if (!ID) return;
    setLoading(true);
    axios
      .get(`${apiKey}/api/edolutions/admin/teacherdetails/${ID}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        // expected: { teacherDetails, bySubjectsData, skillsData, timeSlotData }
        const td = res.data?.teacherDetails || null;
        const subjects = res.data?.bySubjectsData || {};
        const skills = res.data?.skillsData || [];
        const times = res.data?.timeSlotData || [];

        setTeacherDetails(td);
        setBySubjectsData(subjects);
        setBySkillData(Array.isArray(skills) ? skills : []);
        setByTimeSlotData(Array.isArray(times) ? times : []);

        if (td) {
          setFormData({
            bio: td.bio || "",
            degree: td.degree || "",
            school: td.school || "",
            graduation_year: td.graduation_year || "",
            title: td.title || "",
            company: td.company || "",
            start_month: td.start_month || "",
            start_year: td.start_year || "",
            end_month: td.end_month || "",
            end_year: td.end_year || "",
            description: td.description || "",
          });
          setProfileImage(
            td.photo
              ? `${apiKey}/userProfile/${td.photo}`
              : `${apiKey}/userProfile/87654321.png`
          );
        }
      })
      .catch((e) => {
        console.error("teacherdetails error:", e);
        toast.error(t("adminDash.teacherMessage.loadDetailsFailed"), {
          position: "bottom-right",
          theme: "colored",
        });
      })
      .finally(() => setLoading(false));
  }, [ID, admin?.token]);

  // ---------- image upload ----------
  const handleImageUpload = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    if (!["image/png", "image/jpeg"].includes(file.type)) {
      toast.error(t("adminDash.teacherMessage.onlyPngJpeg"), { position: "bottom-right", theme: "colored" });
      e.target.value = "";
      return;
    }
    if (file.size > 1024 * 1024) {
      toast.error(t("adminDash.teacherMessage.max1mb"), { position: "bottom-right", theme: "colored" });
      e.target.value = "";
      return;
    }

    const fd = new FormData();
    fd.append("photo", file);
    fd.append("user_id", ID);

    axios
      .post(`${apiKey}/api/edolutions/teacher-image-upload`, fd, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || t("adminDash.teacherMessage.profileImageUpdated"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });

        // refresh the photo url
        const q = new FormData();
        q.append("user_id", ID);
        return axios.post(`${apiKey}/api/edolutions/get-image`, q, {
          headers: { Authorization: `Bearer ${admin?.token}` },
        });
      })
      .then((res2) => {
        if (Array.isArray(res2.data) && res2.data[0]?.photo_url) {
          setProfileImage(res2.data[0].photo_url);
        }
      })
      .catch((err) => {
        console.error("upload/get-image error:", err);
        toast.error(err.response?.data?.message || t("adminDash.teacherMessage.imageUploadFailed"), {
          position: "bottom-right",
          theme: "colored",
        });
      });
  };

  // ---------- edit handlers ----------
  const handleEditClick = (key) => {
    setEditing((p) => ({ ...p, [key]: !p[key] }));
  };

  const handleChange = (e) => {
    const { name, value } = e?.target || {};
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleSave = () => {
    axios
      .post(`${apiKey}/api/edolutions/admin/updateTeacherDetails/${ID}`, formData, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((response) => {
        setTeacherDetails(response.data?.teacherDetails || teacherDetails);
        setEditing({ about: false, education: false, job: false });
        setErrors({});
        toast.success(t("adminDash.teacherMessage.profileUpdatedSuccessfully"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
      })
      .catch((err) => {
        const apiErr = err?.response?.data;
        if (apiErr?.errors) {
          setErrors(apiErr.errors || {});
          setEditing({ about: true, education: true, job: true });
          toast.error(t("adminDash.teacherMessage.fixHighlightedFields"), {
            position: "bottom-right",
            theme: "colored",
          });
        } else {
          toast.error(t("adminDash.teacherMessage.updateFailed"), {
            position: "bottom-right",
            theme: "colored",
          });
        }
      });
  };

  return (
    <div className="m-3 flex flex-col break-words max-sm:w-[95%] max-sm:mx-auto w-full mb-4 shadow-lg bg-white rounded-3xl border border-gray-100">
      {/* HERO */}
      <div className="relative overflow-hidden rounded-3xl">
        <div
          className="h-48 sm:h-56 w-full bg-cover bg-center"
          style={{ backgroundImage: `url(${Background})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent" />
        <div className="absolute inset-0 flex items-end">
          <div className="p-5 sm:p-8 w-full flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div className="flex items-center gap-4">
              {/* Avatar */}
              <div className="relative">
                {loading ? (
                  <Skeleton className="h-24 w-24 rounded-full border-4 border-white" />
                ) : (
                  <img
                    src={profileImage || `${apiKey}/userProfile/87654321.png`}
                    alt="Profile"
                    className="h-24 w-24 rounded-full border-4 border-white object-cover shadow-md"
                  />
                )}
                <label
                  htmlFor="uploadBtn"
                  className="absolute -bottom-2 -right-2 p-2 rounded-full bg-white shadow cursor-pointer hover:scale-105 transition"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  title={t("adminDash.teacherMessage.uploadPhoto")}
                >
                  <ImUpload className="w-4 h-4 text-gray-700" />
                </label>
                <input
                  id="uploadBtn"
                  type="file"
                  accept="image/png,image/jpeg"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                {showTooltip && (
                  <div className="absolute left-1/2 -translate-x-1/2 mt-10 px-3 py-2 rounded-md bg-white shadow text-xs text-gray-700">
                    {t("adminDash.teacherMessage.pngJpegMax1mb")}
                  </div>
                )}
              </div>
              <div className="text-white">
                <div
                  onClick={() => navigate(-1)}
                  className="flex items-center gap-2 text-sm opacity-80 hover:opacity-100 cursor-pointer"
                >
                  <BiArrowBack /> {t("adminDash.common.back")}
                </div>
                <h1 className="text-2xl sm:text-3xl font-extrabold mt-1 capitalize">
                  {teacherDetails?.user_name || (loading ? t("adminDash.teacherMessage.loading") : t("adminDash.teacherMessage.unnamedTeacher"))}
                </h1>
                <p className="text-sm opacity-90">
                  {teacherDetails?.title ? `${teacherDetails.title} at ${teacherDetails?.company || ""}` : "—"}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              {/* <Link
                to="/admins/edit-subject"
                className="px-4 py-2 rounded-xl bg-white/90 text-gray-800 font-semibold shadow hover:bg-white"
              >
                Edit Specialization
              </Link> */}
              <Link
                to="/admins/home"
                className="px-4 py-2 rounded-xl bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] text-white font-semibold shadow "
              >
                {t("adminDash.teacherMessage.adminHome")}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* BODY */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-5 sm:p-8">
        {/* LEFT */}
        <div className="lg:col-span-2 space-y-6">
          {/* About */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold">{t("adminDash.portfolio.about")}</h2>
              <button
                onClick={() => handleEditClick("about")}
                className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${
                  editing.about ? "bg-gray-100 text-gray-700" : "bg-orange-50 text-orange-700"
                } flex items-center gap-2`}
              >
                {editing.about ? <FaRegTrashAlt /> : <TbBallpen />}
                {editing.about ? t("adminDash.common.cancel") : t("adminDash.common.edit")}
              </button>
            </div>
            {loading ? (
              <Skeleton className="h-20 w-full" />
            ) : editing.about ? (
              <>
                <textarea
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  className="w-full border rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                  rows={5}
                  placeholder={t("adminDash.teacherMessage.writeBio")}
                />
                {errors.bio && <p className="text-red-500 text-sm mt-1">* {errors.bio}</p>}
              </>
            ) : (
              <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {teacherDetails?.bio || t("adminDash.teacherMessage.noBioProvided")}
              </p>
            )}
          </div>

          {/* Education */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold">{t("adminDash.portfolio.education")}</h2>
              <button
                onClick={() => handleEditClick("education")}
                className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${
                  editing.education ? "bg-gray-100 text-gray-700" : "bg-orange-50 text-orange-700"
                } flex items-center gap-2`}
              >
                {editing.education ? <FaRegTrashAlt /> : <TbBallpen />}
                {editing.education ? t("adminDash.common.cancel") : t("adminDash.common.edit")}
              </button>
            </div>
            {loading ? (
              <Skeleton className="h-24 w-full" />
            ) : editing.education ? (
              <div className="grid sm:grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.degree")}</label>
                  <input
                    name="degree"
                    value={formData.degree}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder={t("adminDash.teacherMessage.degreePlaceholder")}
                  />
                  {errors.degree && <p className="text-red-500 text-xs mt-1">* {errors.degree}</p>}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.school")}</label>
                  <input
                    name="school"
                    value={formData.school}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder={t("adminDash.teacherMessage.schoolPlaceholder")}
                  />
                  {errors.school && <p className="text-red-500 text-xs mt-1">* {errors.school}</p>}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.graduationYear")}</label>
                  <input
                    name="graduation_year"
                    value={formData.graduation_year}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., 2022"
                  />
                  {errors.graduation_year && (
                    <p className="text-red-500 text-xs mt-1">* {errors.graduation_year}</p>
                  )}
                </div>
              </div>
            ) : (
              <div className="space-y-1 text-gray-700">
                <p className="font-semibold">{teacherDetails?.degree || "—"}</p>
                <p>{teacherDetails?.school || "—"}</p>
                <p>{t("adminDash.teacherMessage.graduationYear")}: {teacherDetails?.graduation_year || "—"}</p>
              </div>
            )}
          </div>

          {/* Experience */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold">{t("adminDash.teacherMessage.experience")}</h2>
              <button
                onClick={() => handleEditClick("job")}
                className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${
                  editing.job ? "bg-gray-100 text-gray-700" : "bg-orange-50 text-orange-700"
                } flex items-center gap-2`}
              >
                {editing.job ? <FaRegTrashAlt /> : <TbBallpen />}
                {editing.job ? t("adminDash.common.cancel") : t("adminDash.common.edit")}
              </button>
            </div>
            {loading ? (
              <Skeleton className="h-28 w-full" />
            ) : editing.job ? (
              <div className="grid sm:grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.jobTitle")}</label>
                  <input
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., Physics Instructor"
                  />
                  {errors.title && <p className="text-red-500 text-xs mt-1">* {errors.title}</p>}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.company")}</label>
                  <input
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., ABC Academy"
                  />
                  {errors.company && <p className="text-red-500 text-xs mt-1">* {errors.company}</p>}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.startMonth")}</label>
                  <input
                    name="start_month"
                    value={formData.start_month}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., Jan"
                  />
                  {errors.start_month && (
                    <p className="text-red-500 text-xs mt-1">* {errors.start_month}</p>
                  )}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.startYear")}</label>
                  <input
                    name="start_year"
                    value={formData.start_year}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., 2021"
                  />
                  {errors.start_year && (
                    <p className="text-red-500 text-xs mt-1">* {errors.start_year}</p>
                  )}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.endMonth")}</label>
                  <input
                    name="end_month"
                    value={formData.end_month}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., Present / Dec"
                  />
                  {errors.end_month && <p className="text-red-500 text-xs mt-1">* {errors.end_month}</p>}
                </div>
                <div>
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.endYear")}</label>
                  <input
                    name="end_year"
                    value={formData.end_year}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-2.5 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    placeholder="e.g., 2024"
                  />
                  {errors.end_year && <p className="text-red-500 text-xs mt-1">* {errors.end_year}</p>}
                </div>
                <div className="sm:col-span-2">
                  <label className="text-xs text-gray-500">{t("adminDash.teacherMessage.jobDescription")}</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#2DD0A5]"
                    rows={4}
                    placeholder="Briefly describe responsibilities and achievements..."
                  />
                  {errors.description && (
                    <p className="text-red-500 text-xs mt-1">* {errors.description}</p>
                  )}
                </div>
              </div>
            ) : (
              <div className="space-y-1 text-gray-700">
                <p className="font-semibold">{teacherDetails?.title || "—"}</p>
                <p>{teacherDetails?.company || "—"}</p>
                <p>
                  {teacherDetails?.start_month || "—"} {teacherDetails?.start_year || ""} →{" "}
                  {teacherDetails?.end_month || "—"} {teacherDetails?.end_year || ""}
                </p>
                <p className="text-sm text-gray-600">
                  {teacherDetails?.description ? teacherDetails.description : "—"}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="space-y-6">
          {/* Availability */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <h2 className="text-xl font-bold mb-3">{t("adminDash.teacherMessage.availability")}</h2>
            {loading ? (
              <div className="space-y-2">
                <Skeleton className="h-5 w-2/3" />
                <Skeleton className="h-5 w-1/2" />
                <Skeleton className="h-5 w-3/4" />
              </div>
            ) : byTimeSlotData?.length ? (
              <>
                <div className="space-y-3">
                  {byTimeSlotData.slice(0, visibleCount).map((slot) => (
                    <div key={slot.id} className="flex items-center justify-between rounded-xl bg-gray-50 px-3 py-2">
                      <span className="text-sm font-semibold capitalize">{slot.day_name}</span>
                      <span className="text-xs text-gray-600">
                        {formatTime(slot.start_time)} — {formatTime(slot.end_time)}
                      </span>
                    </div>
                  ))}
                </div>
                {byTimeSlotData.length > 4 && (
                  <button
                    onClick={handleToggleView}
                    className="mt-3 text-sm font-semibold text-[#2DD0A5] hover:underline"
                  >
                    {showAll ? t("adminDash.teacherMessage.showLess") : t("adminDash.teacherMessage.viewMore")}
                  </button>
                )}
              </>
            ) : (
              <p className="text-gray-600">{t("adminDash.teacherMessage.noTimeSlots")}</p>
            )}
          </div>

          {/* Skills */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <h2 className="text-xl font-bold mb-3">{t("adminDash.portfolio.skills")}</h2>
            {loading ? (
              <div className="flex flex-wrap gap-2">
                <Skeleton className="h-7 w-20" />
                <Skeleton className="h-7 w-16" />
                <Skeleton className="h-7 w-24" />
              </div>
            ) : bySkillData?.length ? (
              <div className="flex flex-wrap gap-2">
                {bySkillData.map((s) => (
                  <span
                    key={s.id}
                    className="text-xs px-3 py-1.5 rounded-full bg-gray-100 text-gray-700 border border-gray-200"
                  >
                    {s?.skill_name || "—"}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-gray-600">{t("adminDash.teacherMessage.noSkillsAvailable")}</p>
            )}
          </div>

          {/* Overview */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <h2 className="text-xl font-bold mb-3">{t("adminDash.portfolio.profileOverview")}</h2>
            <div className="flex items-center gap-1 text-yellow-400 mb-3">
              <LiaStarSolid /><LiaStarSolid /><LiaStarSolid /><LiaStarSolid /><LiaStarSolid />
              <span className="text-sm text-gray-800 ml-1">5.0</span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 font-semibold mb-1">
              <FaLaptop className="text-gray-700" />
              <span>{t("adminDash.teacherMessage.location")}</span>
            </div>
            <p className="text-sm text-gray-700">
              {teacherDetails?.location || t("adminDash.teacherMessage.noLocationProvided")}
            </p>
          </div>

          {/* Subjects */}
          <div className="rounded-3xl border border-gray-100 bg-white shadow-sm p-6">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold">{t("adminDash.teacherMessage.specializations")}</h2>
              <Link
                to={"/admins/edit-subject"}
                className="text-sm text-orange-600 font-semibold hover:underline flex items-center gap-1"
              >
                <TbBallpen /> {t("adminDash.teacherMessage.manage")}
              </Link>
            </div>

            <div className="flex items-center gap-2 text-gray-900 font-semibold mb-2">
              <FaFile className="text-gray-700" />
              <span>{t("adminDash.teacherMessage.mainProfessionSpecialization")}</span>
            </div>

            {loading ? (
              <div className="space-y-2">
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-6 w-2/3" />
                <Skeleton className="h-6 w-4/5" />
              </div>
            ) : bySubjectsData && Object.keys(bySubjectsData).length ? (
              <div className="divide-y divide-gray-100">
                {Object.keys(bySubjectsData).map((className) => {
                  const open = !!expandedClasses[className];
                  return (
                    <div key={className} className="py-3">
                      <button
                        className="w-full flex items-center justify-between text-left text-gray-800 font-medium hover:text-[#2BACE2]"
                        onClick={() => toggleClass(className)}
                      >
                        <span className="truncate">{className || t("adminDash.teacherMessage.general")}</span>
                        <span className="ml-3">{open ? <IoChevronUp /> : <IoChevronDownOutline />}</span>
                      </button>
                      <div
                        className="transition-all duration-300 ease-out overflow-hidden"
                        style={{
                          maxHeight: open ? 1000 : 0,
                          opacity: open ? 1 : 0,
                        }}
                      >
                        <ul className="mt-3 space-y-2">
                          {Array.isArray(bySubjectsData[className]) &&
                            bySubjectsData[className].map((subject, idx) => (
                              <li
                                key={`${className}-${idx}`}
                                className="rounded-xl bg-gray-50 p-3 border border-gray-100"
                              >
                                <div className="flex items-center justify-between">
                                  <span className="font-semibold text-gray-800">
                                    {subject?.subject || "—"}
                                  </span>
                                  <div className="flex gap-2 text-xs">
                                    {/* <span className="px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                                      Home: {subject?.home_charges ? `Rs${subject.home_charges}` : "N/A"}
                                    </span> */}
                                    <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200">
                                      {t("adminDash.teacherMessage.session")}: {subject?.online_charges ? `Rs${subject.online_charges}` : t("adminDash.teacherMessage.na")}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-gray-600">{t("adminDash.teacherMessage.noSubjectsAvailable")}</p>
            )}
          </div>
        </div>
      </div>

      {/* Sticky Save Bar */}
      {(editing.about || editing.education || editing.job) && (
        <div className="sticky bottom-4 mx-5 sm:mx-8 mb-4">
          <div className="rounded-2xl shadow-2xl bg-white border border-gray-200 p-3 flex items-center justify-end gap-3">
            <button
              onClick={() => setEditing({ about: false, education: false, job: false })}
              className="px-4 py-2 rounded-xl bg-gray-100 text-gray-800 font-semibold hover:bg-gray-200"
            >
              {t("adminDash.common.cancel")}
            </button>
            <button
              onClick={handleSave}
              className=" bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] px-5 py-2 rounded-xl text-white font-semibold "
            >
              {t("adminDash.teacherMessage.saveChanges")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeacherMessage;


